import React, { useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import Layout from "../../layouts/default";
import {
  FaPhoneAlt,
  FaPhone,
  FaDatabase,
  FaTrash,
  FaRecycle,
  FaUsers,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { smartConnectSummary } from "../../store/slices/smartConnect/smartConnectSummary";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

const SummaryCard = ({ title, count, subtitle, icon, color }) => (
  <Card style={{ cursor: "pointer" }} className="h-100 shadow-sm border-0">
    <Card.Body className="d-flex justify-content-between align-items-start">
      <div>
        <div className="text-muted fw-semibold mb-1">{title}</div>
        <h3 className={`fw-bold mb-1`} style={{ color }}>
          {count}
        </h3>
        <div className="text-muted small">{subtitle}</div>
      </div>

      <div
        style={{
          backgroundColor: `${color}20`,
          color,
          padding: "10px",
          borderRadius: "8px",
          fontSize: "18px",
        }}
      >
        {icon}
      </div>
    </Card.Body>
  </Card>
);

function SmartConnectSummary() {
  const dispatch = useDispatch();
  const { summary, loading, error } = useSelector(
    (store) => store.smartConnectSummaryReducer,
  );
  console.log("Summary : ", summary);

  useEffect(() => {
    dispatch(smartConnectSummary());
  }, []);

  if (!hasPermission(PERMISSIONS.SMART_CONNECT.VIEW)) {
    return (
      <div>
        <h3>You do not have permission to view smart connect settings.</h3>
      </div>
    );
  }

  return (
    <Layout>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center gap-2">
          <FaPhoneAlt size={22} />
          <h3 className="m-0">Smart Connect Summary</h3>
        </div>
      </div>

      {/* Summary Cards */}
      <Row className="g-3">
        <Col md={3}>
          <SummaryCard
            title="Active DIDs"
            count={summary?.activeDids || 0}
            subtitle={`Assigned to Agents`}
            icon={<FaPhone />}
            color="#28a745"
          />
        </Col>

        <Col md={3}>
          <SummaryCard
            title="Remaining DIDs"
            count={summary?.remainingDids || 0}
            subtitle="Ready for assignment"
            icon={<FaDatabase />}
            color="#0d6efd"
          />
        </Col>

        <Col md={3}>
          <SummaryCard
            title="Spammed DIDs"
            count={summary?.spammedDids || 0}
            subtitle="Never to use again"
            icon={<FaTrash />}
            color="#dc3545"
          />
        </Col>

        <Col md={3}>
          <SummaryCard
            title="Reserved DIDs"
            count={summary?.reservedDids || 0}
            subtitle="Next to reuse"
            icon={<FaRecycle />}
            color="#ffc107"
          />
        </Col>

        <Col md={3}>
          <SummaryCard
            title="Total Agents"
            count={summary.totalAgents || 0}
            subtitle="All Agent Count"
            icon={<FaUsers />}
            color="#6f42c1"
          />
        </Col>
      </Row>
    </Layout>
  );
}

export default SmartConnectSummary;
